import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import { CloudiaServices } from './configuration/cloudia-services';
import { Configuration } from './configuration/configuration';
import {
  BookingApiModule,
  BookingConfiguration,
} from './generated/booking-api';
import {
  CommentApiModule,
  CommentConfiguration,
} from './generated/comment-api';
import {
  ProjectApiModule,
  ProjectConfiguration,
} from './generated/project-api';
import { SearchApiModule, SearchConfiguration } from './generated/search-api';
import {
  SearchSuggestionApiModule,
  SearchSuggestionConfiguration,
} from './generated/search-suggestions-api';
import {
  SelectFetchApiModule,
  SelectFetchConfiguration,
} from './generated/select-fetch-api';
import { UserApiModule, UserConfiguration } from './generated/user-api';
import {
  WorkbenchApiModule,
  WorkbenchConfiguration,
} from './generated/workbench-api';
import {
  ImpersonationApiModule,
  ImpersonationConfiguration,
} from '@cloudia-shared/apis/generated/impersonation-api';
import {
  FeedbackApiModule,
  FeedbackConfiguration,
} from './generated/feedback-api';

const services = new CloudiaServices();

const getConfig = <T>(serviceKey: keyof CloudiaServices): T => {
  const service = services.get(serviceKey);

  if (environment.localBackend) {
    return new Configuration({
      basePath: `http://localhost:${service.port}/${service.basePath}`,
    }) as unknown as T;
  }

  return new Configuration({
    basePath: environment.apiUrl.replace('api/', `${service.basePath}`),
  }) as unknown as T;
};

@NgModule({
  imports: [
    ProjectApiModule.forRoot(() =>
      getConfig<ProjectConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    SelectFetchApiModule.forRoot(() =>
      getConfig<SelectFetchConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    WorkbenchApiModule.forRoot(() =>
      getConfig<WorkbenchConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    SearchApiModule.forRoot(() =>
      getConfig<SearchConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    BookingApiModule.forRoot(() =>
      getConfig<BookingConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    CommentApiModule.forRoot(() =>
      getConfig<CommentConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    UserApiModule.forRoot(() =>
      getConfig<UserConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    SearchSuggestionApiModule.forRoot(() =>
      getConfig<SearchSuggestionConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    ImpersonationApiModule.forRoot(() =>
      getConfig<ImpersonationConfiguration>('CUSTOMER_MANAGEMENT')
    ),
    FeedbackApiModule.forRoot(() =>
      getConfig<FeedbackConfiguration>('CUSTOMER_MANAGEMENT')
    ),
  ],
})
export class CloudiaApisModule {}
